import {audioManager, AudioType} from '../../../shared/scripts/Sound'
import {UIPopupRulebook} from '../../../shared/scripts/ui_popup/UIPopupRulebook'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {RulebookPage} from '../../../../shared/enums/RulebookEnums'

export class UIWFooterController {
    private readonly rulesButton: HTMLDivElement

    constructor() {
        this.rulesButton = document.getElementById('footer-rules-button') as HTMLDivElement
        this.initRulesButton()
    }

    private initRulesButton() {
        setElementOnClick(this.rulesButton, () => {
            audioManager.play(AudioType.Click)
            new UIPopupRulebook(RulebookPage.Classic4P).show()
        })
    }
}
